import classnames from 'classnames/bind'
import { useFormikContext } from 'formik'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'next-i18next'

// Components
import FieldItem from '@/components/common/Form/components/FieldItem'
import Form from '@/components/common/Form'
import Button from '@/components/common/Button'

// Constants
import { FIELD_TYPE } from '@/constants/fieldType'
import { COOKIE_DATA } from '@/constants/cookieKey'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

const SettingUserNamePopupContentForm = (props: any) => {
  const {
    isLoadingFetchPChomeToken,
    isLoadingUpdateNickname,
    isErrorFetchPchomeToken,
    fetchPchomeTokenErrorData,
    isErrorUpdateNickname,
    updateNicknameErrorData,
  } = props

  const { handleSubmit } = useFormikContext()
  const { t } = useTranslation()

  const [cookies] = useCookies([COOKIE_DATA.PCHOME_UUID])
  const pchome_uuid = cookies[COOKIE_DATA.PCHOME_UUID]

  return (
    <div className={cx('setting-username-popup-content')}>
      <div className={cx('setting-username-popup-content__uid')}>
        <span>uid:{pchome_uuid}:uid</span>
      </div>
      <div className={cx('setting-username-popup-content__content')}>
        <FieldItem name='username' title={t('LiveRoom_Portrait_Release_Agreement_Popup_Nickname_Placeholder')} fieldType={FIELD_TYPE.INPUT}>
          <Form.InputField type='username' />
        </FieldItem>
      </div>

      {isErrorFetchPchomeToken && (
        <div className={cx('setting-username-popup-content__error-message')}>{fetchPchomeTokenErrorData?.message || ''}</div>
      )}
      {isErrorUpdateNickname && <div className={cx('setting-username-popup-content__error-message')}>{updateNicknameErrorData?.message || ''}</div>}

      <div className={cx('setting-username-popup-content__action-button')}>
        <Button size='md' onClick={handleSubmit} disabled={isLoadingFetchPChomeToken || isLoadingUpdateNickname}>
          {t('LiveRoom_Portrait_Release_Agreement_Popup_Submit')}
        </Button>
      </div>
    </div>
  )
}

export default SettingUserNamePopupContentForm
